module.exports = __webpack_public_path__ + "img/farewell_11.6c7d3fdf.jpg";